// The shipping zone editor's country rows (backfill PR 32): a field change on the country
// being edited or added (ZoneEditScreen held one branch for each) and the empty country a
// new row starts from.
export const countryWithFieldChange = (country, field, lang, value) => {
  if (field === 'countryCode') {
    return { ...country, countryCode: value.toUpperCase() };
  }

  return {
    ...country,
    names: {
      ...country.names,
      [lang]: {
        ...country.names[lang],
        [field]:
          field === 'secondary' ? value.split(',').map((v) => v.trim()) : value,
      },
    },
  };
}; // the country with one field changed: the code upper-cased, the secondary names split at the commas, the other names as typed

export const emptyCountry = () => ({
  countryCode: '',
  names: {
    en: {
      primary: '',
      specialTerritory: '',
      supplementary: '',
      secondary: [],
    },
    de: {
      primary: '',
      specialTerritory: '',
      supplementary: '',
      secondary: [],
    },
  },
}); // the country a new row starts from
